/** A function that returns an object containing all the different texts needed
 * to create a React component that renders text and the links between the texts.
 *
 * @param tag The custom tag that should be descructured from the tags in the text param.
 * @param text The text which with custom tags that should match the passed tag.
 * @returns an object contain an object contain 4 different texts.
 * `originalText`: The original text passed as the `text` prop.
 * `beforeLinkText`: The text prior to the custom tag as defined by the `tag` prop.
 * `linkText`: The text inbetween the custom tags.
 * `afterLinkText`: The text after the link as defined by the custom tags.
 */
export const getTextFromTags = (tag: string, text: string) => {
    const expression = new RegExp(`(.*)<${tag}>(.*)</${tag}>(.*)`);
    const exec = expression.exec(text);
    if (!exec) {
        console.error(`Regex matching failed on text '${text}'`);
        return undefined;
    }
    const [originalText, beforeLinkText, linkText, afterLinkText] = exec;

    return { originalText, beforeLinkText, linkText, afterLinkText };
};
